import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/home";
import Testimonials from "./pages/testimonials";
import NoPage from "./pages/NoPage";
import About from "./pages/about";
import Services from "./pages/services";
import Logistics from "./pages/termsandcondition";
import Team from "./pages/team";
import TeamDetails from "./pages/team-details";
import ProjectDetails from "./pages/project-details";
import Project from "./pages/project";
import BlogDetails from "./pages/blog-details";
import Blog from "./pages/blog";
import Contact from "./pages/contact";
import Courses from "./pages/courses";
import Gallery from "./pages/gallery";
import Brochure from "./pages/brochure";
import Admission from "./pages/admission";
import Terms from "./pages/termsandcondition";
import Admissionbtn from "./components/Admissionbtn";
import Management from "./pages/our management";
import Acting from "./pages/acting";
import Direction from "./pages/direction";
import Cinemtography from "./pages/cinemtography";
import InfluencerCreators from "./pages/influencercreator";
import Photography from "./pages/photography";
import Videoediting from "./pages/videoediting";
import Scriptwriting from "./pages/scriptwriting";
import DubbingAndVoiceover from "./pages/dubbingandvoiceover";
import Digitalmarketing from "./pages/digitalmarketing";
import PersonalityDevlopment from "./pages/personalitydevlopment";
import SoundEngineering from "./pages/soundengineering";
import VisualEffect from "./pages/visualeffect";
import Policy from "./pages/Privacy-Policy";
import "./App.css"

function ScrollToTop() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return null;
}

export default function App() {
  return (
      <BrowserRouter>
        <ScrollToTop />
        <Admissionbtn />
        <Routes>
          <Route index element={<Home />} />
          <Route path="*" element={<NoPage />} />
          <Route path="terms" element={<Logistics />} />
          <Route path="about" element={<About />} />
          <Route path="testimonials" element={<Testimonials />} />
          <Route path="faculty" element={<Team />} />
          <Route path="team-details" element={<TeamDetails />} />
          <Route path="services" element={<Services />} />
          <Route path="infrastructure-details/:id" element={<ProjectDetails />} />
          <Route path="infrastructure" element={<Project />} />
          <Route path="blog-details/:id" element={<BlogDetails />} />
          <Route path="blog" element={<Blog />} />
          <Route path="contact" element={<Contact />} />
          <Route path="courses" element={<Courses />} />
          <Route path="gallery" element={<Gallery />} />
          <Route path="brochure" element={<Brochure />} />
          <Route path="admission" element={<Admission />} />
          <Route path="/blog/:id" element={<BlogDetails />} />
          <Route path="terms-and-condition" element={<Terms />} />
          <Route path="our-management" element={<Management />} />
          <Route path="/courses/acting" element={<Acting />} />
          <Route path="/courses/direction" element={<Direction />} />
          <Route path="/courses/cinemetography" element={<Cinemtography />} />
          <Route path="/courses/influencer-creator" element={<InfluencerCreators />} />
          <Route path="/courses/photography" element={<Photography />} />
          <Route path="/courses/video-editing" element={<Videoediting />} />
          <Route path="/courses/script-writing" element={<Scriptwriting />} />
          <Route path="/courses/dubbing-and-voiceover" element={<DubbingAndVoiceover />} />
          <Route path="/courses/digital-marketing" element={<Digitalmarketing />} />
          <Route path="/courses/personality-development" element={<PersonalityDevlopment />} />
          <Route path="/courses/sound-engineering" element={<SoundEngineering />} />
          <Route path="/courses/visual-effects" element={<VisualEffect />} />
          <Route path="/privacy-policy" element={<Policy/>} />

        </Routes>
      </BrowserRouter>
  );
}
